<template>
  <div class="grid gap-6 w-full">
    <div class="flex">
      <!-- Show submenu only if item has submenu items -->
      <details v-if="hasSubmenu" class="group w-full" @click="isActive = true">
        <summary class="flex justify-between font-medium cursor-pointer list-none">
          <span>{{ $t(item.label) }}</span>
          <ChevronRightIcon class="h-4" />
        </summary>
      </details>
      <!-- Direct navigation for items with 'to' but no submenu -->
      <RouterLink
        v-else-if="item.to && item.to !== ''"
        :to="item.to"
        class="flex justify-between font-medium cursor-pointer w-full"
        @click="closeMenu()">
        <span>{{ $t(item.label) }}</span>
      </RouterLink>
      <!-- Plain text for items with neither 'to' nor submenu -->
      <span v-else class="flex justify-between font-medium w-full">
        {{ $t(item.label) }}
      </span>
      <!-- Submenu transition -->
      <Teleport to="body">
        <transition
          enter-active-class="transition duration-200 ease-out"
          enter-from-class="translate-x-5 opacity-0"
          enter-to-class="translate-x-0 opacity-100"
          leave-active-class="transition duration-150 ease-in"
          leave-from-class="translate-x-0 opacity-100"
          leave-to-class="translate-x-5 opacity-0">
          <MainMenuLinks
            v-if="isActive && hasSubmenu"
            :parent-label="item.label"
            :item
            class="fixed z-[60]"
            style="left: 0; top: 0; right: 0; bottom: 0; width: 100vw; height: 100vh; max-width: 100vw; margin: 0; padding: 0;"
            mobile
            @close="isActive = false" />
        </transition>
      </Teleport>
    </div>
  </div>
</template>

<script setup lang="ts">
import MainMenuLinks from "./MainMenuLinks.vue";
import { ref, computed } from "vue";
import { ChevronRightIcon } from "@heroicons/vue/24/outline";

const props = defineProps<{ item }>();

const isActive = ref(false);

const hasSubmenu = computed(() => {
  return props.item?.items && props.item.items.length > 0;
});

const closeMenu = () => {
  emit("close");
};

const emit = defineEmits<{ close: [] }>();
</script>
